module.exports = __webpack_public_path__ + "img/快乐绿色-选中.e2b8cc61.png";